import { PayloadAction } from "@reduxjs/toolkit";
import { FinanceState } from "../../models/FinanceState";
import { SearchUsersForVendorPayload } from "../../payload/SearchUsersForVendor/SearchUsersForVendorPayload";

const searchUsersForVendorFetch = (state: FinanceState, actions: PayloadAction<SearchUsersForVendorPayload>) => {
    state.isLoading = true;
}

export default searchUsersForVendorFetch;